import { forwardRef, useContext, useState } from "react";
import {
  CircularProgress,
  Dialog,
  DialogContent,
  DialogContentText,
  Slide,
} from "@material-ui/core";
import "./style.css";
import CloseIcon from "@material-ui/icons/Close";
import { paymentData } from "utils/constant";
import { trackButtonClick } from "utils";
import { updateSubscription } from "services/auth";
import AuthContext from "contexts/authContext";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const FreeTrialDialog = (props) => {
  const { dialogOpen, setDialogOpen } = props;
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("monthly");
  const { auth } = useContext(AuthContext);
  const TrialTaken = auth.userData.TrialTaken;
  const handleClose = (e) => {
    trackButtonClick("FreeTrialDialog", "Close");
    e.stopPropagation();
    e.preventDefault();
    setDialogOpen(false);
  };

  const getUpgread = async () => {
    setLoading(true);
    let res = await updateSubscription(
      activeTab === "monthly" ? paymentData.monthlyId : paymentData.yearlyId
    );
    window.location.href = res.data.url;
    setLoading(false);
  };

  let startDate = new Date();
  let endDate = new Date(startDate.setDate(startDate.getDate() + 5));

  // Format the date as "Mar 20, 2023"
  let formattedEndDate = endDate.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });

  console.log(formattedEndDate); // Output: "Mar 20, 2023"

  return (
    <>
      <Dialog
        open={dialogOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        fullWidth
        PaperProps={{
          style: {
            zIndex: "1200 !important",
            // padding: "20px",
            // paddingTop: "0px",
            borderRadius: "32px",
          },
        }}
        maxWidth="xs"
        BackdropProps={{ style: { zIndex: "1200 !important" } }}
      >
        <DialogContent style={{ zIndex: "1200 !important" }}>
          <DialogContentText id="alert-dialog-slide-description">
            <div className="freetrialend-dialog-close" onClick={handleClose}>
              <CloseIcon overlineThickness={20} strikethroughThickness={7} />
            </div>
            <div className="freetrial-dialog">
              {TrialTaken ? (
                <div className="title">Upgrade now</div>
              ) : (
                <div className="title">Unlimited writing for $1</div>
              )}

              <div className="sub-title">You’re almost there!</div>
              <div className="plan-tabs">
                <div
                  className={`annual plan ${
                    activeTab === "annual" ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveTab("annual");
                  }}
                >
                  Annual plan
                </div>
                <div
                  className={`monthly plan ${
                    activeTab === "monthly" ? "active" : ""
                  }`}
                  onClick={() => {
                    setActiveTab("monthly");
                  }}
                >
                  Monthly plan
                </div>
              </div>
              <div className="price-text">
                $
                {(activeTab === "monthly"
                  ? paymentData.monthlyPrice
                  : paymentData.yearlyPrice / 12
                ).toFixed(2)}
                /month
              </div>
              {!TrialTaken && (
                <div className="term">
                  <>*Charged {activeTab} after a 5 day trial ends</>
                </div>
              )}
              <div className="price-break-down">
                {!TrialTaken && (
                  <div className="price">
                    <div className="date">Due {formattedEndDate}</div>
                    <div className="price-value">
                      $
                      {(activeTab === "monthly"
                        ? paymentData.monthlyPrice
                        : paymentData.yearlyPrice
                      ).toFixed(2)}
                    </div>
                  </div>
                )}
                <div className="price free-price">
                  <div className="date">Due today</div>
                  <div className="price-value">
                    $
                    {TrialTaken
                      ? (activeTab === "monthly"
                          ? paymentData.monthlyPrice
                          : paymentData.yearlyPrice
                        ).toFixed(2)
                      : "1.00"}
                  </div>
                </div>
              </div>
              <div className="continue-btn hover-zoom">
                {loading && (
                  <div className="continue-loader">
                    <CircularProgress
                      thickness={4.5}
                      size={20}
                      style={{ color: "white" }}
                    />
                  </div>
                )}
                <svg
                  width="292"
                  height="44"
                  viewBox="0 0 292 44"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={() => getUpgread()}
                >
                  <rect
                    y="3.05176e-05"
                    width="292"
                    height="44"
                    rx="12"
                    fill={loading ? "gray" : "#CF5FA6"}
                  />
                  {loading ? (
                    <></>
                  ) : (
                    <>
                      <path
                        d="M110.755 18.2569C110.276 18.2569 109.848 18.3435 109.47 18.5166C109.096 18.6898 108.779 18.9405 108.52 19.2686C108.26 19.5922 108.062 19.9864 107.925 20.4512C107.788 20.9115 107.72 21.431 107.72 22.0098C107.72 22.7845 107.829 23.4522 108.048 24.0127C108.267 24.5687 108.599 24.9971 109.046 25.2979C109.493 25.5941 110.058 25.7422 110.741 25.7422C111.165 25.7422 111.577 25.7012 111.979 25.6192C112.38 25.5371 112.794 25.4255 113.223 25.2842V26.6787C112.817 26.8382 112.407 26.9545 111.992 27.0274C111.577 27.1003 111.099 27.1367 110.557 27.1367C109.536 27.1367 108.688 26.9248 108.014 26.501C107.344 26.0772 106.842 25.4802 106.51 24.71C106.182 23.9398 106.018 23.0375 106.018 22.003C106.018 21.2464 106.122 20.5537 106.332 19.9248C106.542 19.2959 106.847 18.7536 107.248 18.2979C107.649 17.8376 108.144 17.4844 108.731 17.2383C109.324 16.9877 110.001 16.8623 110.762 16.8623C111.263 16.8623 111.755 16.9193 112.238 17.0332C112.726 17.1426 113.177 17.2998 113.592 17.5049L113.018 18.8584C112.671 18.6944 112.309 18.5531 111.931 18.4346C111.552 18.3161 111.16 18.2569 110.755 18.2569ZM121.904 23.1992C121.904 23.8282 121.822 24.3864 121.658 24.8741C121.494 25.3617 121.255 25.7741 120.94 26.1114C120.626 26.444 120.248 26.6992 119.806 26.877C119.364 27.0502 118.865 27.1367 118.309 27.1367C117.789 27.1367 117.313 27.0502 116.88 26.877C116.447 26.6992 116.071 26.444 115.752 26.1114C115.438 25.7741 115.194 25.3617 115.021 24.8741C114.847 24.3864 114.761 23.8282 114.761 23.1992C114.761 22.3653 114.904 21.6589 115.191 21.0801C115.483 20.4968 115.898 20.0524 116.436 19.7471C116.973 19.4418 117.614 19.2891 118.356 19.2891C119.054 19.2891 119.669 19.4418 120.202 19.7471C120.735 20.0524 121.152 20.4968 121.453 21.0801C121.754 21.6634 121.904 22.3698 121.904 23.1992ZM116.415 23.1992C116.415 23.7507 116.481 24.2224 116.613 24.6143C116.75 25.0062 116.96 25.307 117.242 25.5166C117.525 25.7217 117.889 25.8242 118.336 25.8242C118.783 25.8242 119.147 25.7217 119.43 25.5166C119.712 25.307 119.92 25.0062 120.052 24.6143C120.184 24.2224 120.25 23.7507 120.25 23.1992C120.25 22.6478 120.184 22.1807 120.052 21.7979C119.92 21.4105 119.712 21.1166 119.43 20.916C119.147 20.711 118.78 20.6084 118.329 20.6084C117.664 20.6084 117.178 20.8317 116.873 21.2784C116.568 21.725 116.415 22.3653 116.415 23.1992ZM127.694 19.2891C128.547 19.2891 129.21 19.5101 129.684 19.9522C130.162 20.3897 130.401 21.0938 130.401 22.0645V27H128.795V22.3653C128.795 21.7774 128.674 21.3376 128.433 21.0459C128.191 20.7497 127.817 20.6016 127.312 20.6016C126.578 20.6016 126.067 20.8272 125.78 21.2784C125.498 21.7295 125.356 22.3835 125.356 23.2403V27H123.75V19.4326H125.001L125.227 20.458H125.315C125.479 20.1937 125.682 19.9772 125.924 19.8086C126.17 19.6354 126.443 19.5056 126.744 19.419C127.049 19.3324 127.366 19.2891 127.694 19.2891ZM135.467 25.8379C135.676 25.8379 135.884 25.8197 136.089 25.7832C136.294 25.7422 136.481 25.6944 136.649 25.6397V26.8565C136.472 26.9339 136.242 27 135.959 27.0547C135.676 27.1094 135.382 27.1367 135.077 27.1367C134.649 27.1367 134.264 27.0661 133.922 26.9248C133.58 26.779 133.309 26.5306 133.108 26.1797C132.908 25.8288 132.808 25.3435 132.808 24.7237V20.6563H131.775V19.9385L132.883 19.3711L133.409 17.751H134.421V19.4326H136.588V20.6563H134.421V24.7032C134.421 25.086 134.517 25.3708 134.708 25.5576C134.899 25.7445 135.152 25.8379 135.467 25.8379ZM139.794 19.4326V27H138.188V19.4326H139.794ZM139.001 16.5342C139.247 16.5342 139.459 16.6003 139.637 16.7325C139.819 16.8646 139.91 17.0925 139.91 17.416C139.91 17.7351 139.819 17.9629 139.637 18.0996C139.459 18.2318 139.247 18.2979 139.001 18.2979C138.746 18.2979 138.529 18.2318 138.352 18.0996C138.178 17.9629 138.092 17.7351 138.092 17.416C138.092 17.0925 138.178 16.8646 138.352 16.7325C138.529 16.6003 138.746 16.5342 139.001 16.5342ZM146.042 19.2891C146.894 19.2891 147.557 19.5101 148.031 19.9522C148.51 20.3897 148.749 21.0938 148.749 22.0645V27H147.143V22.3653C147.143 21.7774 147.022 21.3376 146.78 21.0459C146.539 20.7497 146.165 20.6016 145.659 20.6016C144.925 20.6016 144.415 20.8272 144.128 21.2784C143.845 21.7295 143.704 22.3835 143.704 23.2403V27H142.098V19.4326H143.349L143.574 20.458H143.663C143.827 20.1937 144.03 19.9772 144.271 19.8086C144.518 19.6354 144.791 19.5056 145.092 19.419C145.397 19.3324 145.714 19.2891 146.042 19.2891ZM157.595 19.4326V27H156.33L156.111 25.9815H156.022C155.863 26.2412 155.66 26.4577 155.414 26.6309C155.168 26.7995 154.895 26.9248 154.594 27.0069C154.293 27.0935 153.976 27.1367 153.644 27.1367C153.074 27.1367 152.586 27.041 152.181 26.8496C151.78 26.6537 151.472 26.3529 151.258 25.9473C151.044 25.5417 150.937 25.0176 150.937 24.375V19.4326H152.55V24.0742C152.55 24.6621 152.668 25.1019 152.905 25.3936C153.147 25.6853 153.521 25.8311 154.026 25.8311C154.514 25.8311 154.901 25.7308 155.188 25.5303C155.476 25.3298 155.678 25.0336 155.797 24.6416C155.92 24.2497 155.981 23.7689 155.981 23.1992V19.4326H157.595ZM162.913 19.2891C163.588 19.2891 164.166 19.4281 164.649 19.7061C165.132 19.9841 165.504 20.3783 165.764 20.8887C166.023 21.3991 166.153 22.0098 166.153 22.7207V23.5821H161.102C161.12 24.3158 161.316 24.8809 161.689 25.2774C162.068 25.6739 162.596 25.8721 163.275 25.8721C163.758 25.8721 164.191 25.8265 164.574 25.7354C164.962 25.6397 165.36 25.5007 165.771 25.3184V26.6241C165.392 26.8018 165.007 26.9317 164.615 27.0137C164.223 27.0957 163.754 27.1367 163.207 27.1367C162.464 27.1367 161.81 26.9932 161.245 26.7061C160.685 26.4144 160.245 25.9815 159.926 25.4073C159.611 24.833 159.454 24.1198 159.454 23.2676C159.454 22.42 159.598 21.6999 159.885 21.1075C160.172 20.515 160.575 20.0638 161.095 19.7539C161.614 19.444 162.22 19.2891 162.913 19.2891ZM162.913 20.4991C162.407 20.4991 161.997 20.6631 161.683 20.9912C161.373 21.3194 161.19 21.8002 161.136 22.4336H164.581C164.576 22.0554 164.513 21.7204 164.39 21.4287C164.271 21.1371 164.089 20.9092 163.843 20.7451C163.601 20.5811 163.291 20.4991 162.913 20.4991Z"
                        fill="white"
                      />
                      <path
                        d="M184.53 22.5304C184.823 22.2375 184.823 21.7626 184.53 21.4697L179.757 16.6967C179.464 16.4038 178.99 16.4038 178.697 16.6967C178.404 16.9896 178.404 17.4645 178.697 17.7574L182.939 22L178.697 26.2427C178.404 26.5356 178.404 27.0104 178.697 27.3033C178.99 27.5962 179.464 27.5962 179.757 27.3033L184.53 22.5304ZM174 21.25C173.586 21.25 173.25 21.5858 173.25 22C173.25 22.4142 173.586 22.75 174 22.75V21.25ZM184 21.25H174V22.75H184V21.25Z"
                        fill="white"
                      />
                    </>
                  )}
                </svg>
                <div className="cancel-anytime">Cancel anytime!</div>
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default FreeTrialDialog;
